{
  "header": {
    "title": "Explorateur de données",
    "description": "Créez, gérez et analysez des enquêtes auprès des employés pour obtenir des informations plus approfondies",
    "createButton": "Créer un nouveau rapport"
  },
  "content": {
    "searchInput": {
      "placeholder": "Rechercher des enquêtes"
    },
    "tagsDropdown": {
      "triggerLabel": "Étiquettes",
      "placeholder": "Rechercher une étiquette",
      "options": {
        "employeeEngagement": "Engagement des employés",
        "workplaceCulture": "Culture d'entreprise",
        "teamSatisfaction": "Satisfaction de l'équipe",
        "performanceFeedback": "Retour sur la performance",
        "organizationalImprovement": "Amélioration organisationnelle",
        "usa": "États-Unis",
        "europe": "Europe",
        "asia": "Asie",
        "ukraine": "Ukraine"
      }
    }
  },
  "columns": {
    "reportName": "Nom du rapport",
    "tags": "Étiquettes",
    "creator": "Créateur",
    "status": "Statut"
  },
  "detailsPage": {
    "header": {
      "backButton": "Retour à l'explorateur de données",
      "description": "Créez, gérez et analysez des enquêtes auprès des employés pour obtenir des informations plus approfondies",
      "shareReportButton": "Partager le rapport",
      "editReportButton": "Modifier le rapport"
    },
    "cardMetrcisSection": {
      "title": "Nombre moyen d'employés"
    },
    "leaderMetrcisSection": {
      "title": "Indicateurs du responsable",
      "description": "Ce graphique montre comment les employés ayant différentes anciennetés ont répondu à l'affirmation.",
      "chart": {
        "title": "Score de satisfaction au travail"
      }
    }
  },
  "builder": {
    "header": {
      "backButton": "Retour à l'explorateur de données",
      "addDescriptionButton": "Ajouter une description",
      "cancelButton": "Annuler",
      "saveReportButton": "Enregistrer le rapport"
    },
    "content": {
      "notSupportedLayout": "La disposition 1/3 n'est pas prise en charge",
      "inputs": {
        "dateRange": {
          "label": "Plage de dates"
        },
        "department": {
          "label": "Département"
        },
        "leader": {
          "label": "Responsable"
        },
        "gender": {
          "label": "Sexe"
        },
        "location": {
          "label": "Emplacement"
        },
        "tenure": {
          "label": "Ancienneté"
        }
      },
      "charts": {
        "heatmap": {
          "title": "Intensité par département"
        },
        "distribution": {
          "title": "Répartition des réponses"
        },
        "improvement": {
          "title": "Top 5 des questions en amélioration sur l'équilibre vie pro/perso"
        },
        "decline": {
          "title": "Top 5 des questions en déclin sur l'équilibre vie pro/perso"
        },
        "text": {
          "title": "Indicateurs du responsable",
          "description": "Aperçu des performances du responsable et des retours"
        }
      }
    },
    "sidebar": {
      "text": {
        "textHeading": {
          "title": "En-tête",
          "description": "Nombre total d'employés dans l'enquête",
          "data": {
            "title": "Indicateurs du responsable",
            "description": "Aperçu des indicateurs de performance et des retours du responsable"
          }
        },
        "textSubtitle": {
          "title": "Sous-titre",
          "description": "Nombre total d'employés dans l'enquête",
          "data": {
            "title": "Indicateurs du responsable",
            "description": "Aperçu des indicateurs de performance et des retours du responsable"
          }
        },
        "textBodyText": {
          "title": "Corps du texte",
          "description": "Nombre total d'employés dans l'enquête",
          "data": {
            "title": "Indicateurs du responsable",
            "description": "Aperçu des indicateurs de performance et des retours du responsable"
          }
        }
      },
      "numbers": {
        "numbersAvgEmployee": {
          "title": "Nombre moyen d'employés",
          "description": "Nombre total d'employés dans l'enquête",
          "data": {
            "title": "Nombre moyen d'employés",
            "description": "Nombre total d'employés dans l'enquête"
          }
        },
        "numbersResponseCount": {
          "title": "Nombre de réponses",
          "description": "Nombre de réponses soumises",
          "data": {
            "title": "Nombre de réponses",
            "description": "Nombre de réponses soumises"
          }
        },
        "numbersParticipationRate": {
          "title": "Taux de participation",
          "description": "Pourcentage des employés ayant répondu",
          "data": {
            "title": "Taux de participation",
            "description": "Pourcentage des employés ayant répondu"
          }
        },
        "numbersAverageScore": {
          "title": "Score moyen",
          "description": "Pourcentage des employés ayant répondu",
          "data": {
            "title": "Score moyen",
            "description": "Pourcentage des employés ayant répondu"
          }
        },
        "numbersEnps": {
          "title": "eNPS",
          "description": "Pourcentage des employés ayant répondu",
          "data": {
            "title": "eNPS",
            "description": "Pourcentage des employés ayant répondu"
          }
        }
      },
      "graphs": {
        "graphsAvgEmployee": {
          "title": "Nombre moyen d'employés",
          "description": "Nombre total d'employés dans l'enquête",
          "data": {
            "title": "Nombre moyen d'employés",
            "description": "Nombre total d'employés dans l'enquête"
          }
        }
      }
    }
  }
}
